/*
*
* TriggerTimeline Api
*
* @version 1.0.0
* @author Patrizia Petrera
* @since 11-Mar-2025
*/

import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'

if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/triggerTimeline/triggerTimeline')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}

export async function doRetrieveTTL (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/communication-service/retrieve-ttl',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function setRetrieveTTLread (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/communication-service/read-ttl',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
